module.exports = __webpack_public_path__ + "static/media/ORCHE.88ad6c0c.png";